// extracted by mini-css-extract-plugin
export default {"root":"TK7jjhMY0rp_2KLyoVMf"};